/* Publishing this tenant's scoring model — how rule results aggregate into a score.
 *
 * **The same editor as the Scores side panel**, on its own page for the Admin → Configuration route.
 * One editor in two places, so there is one answer to "how is a model published": publishing alters
 * the meaning of every score computed under it, and two forms would be two chances to disagree about
 * what gets sent.
 *
 * This is the only surface in the product that can publish a scoring model, and nothing is scored
 * until one exists — which is why it stays reachable from Configuration as well as from Scores.
 */

import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { isAdmin, useIdentity } from '@/entities/session';
import { PageHeader } from '@/shared/ui/PageHeader';

import { ScoreModelEditor } from './ScoreModelEditor';

export function ScoreModelScreen(): ReactElement {
  const { t } = useTranslation();
  const identity = useIdentity();

  return (
    <section className="lq-sm-page">
      <PageHeader
        title={t('scoring.model.title')}
        lede={t('scoring.model.screenLede')}
        help={t('help.feature.scoreModel')}
      />
      <div className="lq-sm-page__card">
        <ScoreModelEditor canPublish={isAdmin(identity.data)} />
      </div>
    </section>
  );
}
